import { useEffect, useState } from 'react';

type UseBackgroundImageProps = {
  localUrl?: string;
  serverUrl?: string;
  onServerLoaded?: () => void;
};

export function useBackgroundImage({ localUrl, serverUrl, onServerLoaded }: UseBackgroundImageProps) {
  const [bgUrl, setBgUrl] = useState(serverUrl || '');
  const [bgLocalUrl, setLocalBgUrl] = useState(localUrl || '');

  useEffect(() => {
    setLocalBgUrl(localUrl || '');
  }, [localUrl]);

  useEffect(() => {
    if (!serverUrl) {
      return setBgUrl('');
    }

    // Preload the server image
    const img = new Image();
    img.src = serverUrl;
    let cancelled = false;

    img.onload = () => {
      if (cancelled) return;
      setBgUrl(serverUrl); // swap only when fully loaded
      onServerLoaded?.();
    };

    img.onerror = () => {
      console.warn('Failed to load server background image, keeping local.');
    };

    return () => {
      cancelled = true;
      img.onload = null;
      img.onerror = null;
    };
  }, [serverUrl]);

  return bgUrl || bgLocalUrl;
}
